import { render } from "./DeleteUserModal.vue?vue&type=template&id=ef0964d8&ts=true"
import script from "./DeleteUserModal.vue?vue&type=script&lang=ts"
export * from "./DeleteUserModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__